import { render } from "./LatestNews.vue?vue&type=template&id=227a983c&scoped=true&ts=true"
import script from "./LatestNews.vue?vue&type=script&lang=ts"
export * from "./LatestNews.vue?vue&type=script&lang=ts"

import "./LatestNews.vue?vue&type=style&index=0&id=227a983c&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227a983c"]])

export default __exports__